import { tassign } from 'tassign';
import * as _ from 'lodash';

// Own feature
import { IBreadcrumbItem } from '../model/breadcrumb.interface';

import {
    BREADCRUMB_RESET_STATE,

    BREADCRUMB_SET_INITIAL_CRUMB,
    BREADCRUMB_ADD_CRUMB,
    BREADCRUMB_ADD_CRUMB_AND_SHRING,
    BREADCRUMB_SHRINK_TO_CRUMB_FROM_START,

    BREADCRUMB_SET_SELECTED_CRUMB
} from './actions';

export interface IBreadCrumbState {
    crumbs0: IBreadcrumbItem[];
    crumbSelected0: IBreadcrumbItem | null;
}

export const BREADCRUMB_INITIAL_STATE: IBreadCrumbState = {
    crumbs0: null,
    crumbSelected0: null
};

export function breadcrumbReducer(state: IBreadCrumbState = BREADCRUMB_INITIAL_STATE, action): IBreadCrumbState {
    switch (action.type) {
        case BREADCRUMB_RESET_STATE: return resetState(state, action);
        case BREADCRUMB_SET_INITIAL_CRUMB: return setInitialCrumb(state, action);
        case BREADCRUMB_ADD_CRUMB: return addCrumb(state, action);
        case BREADCRUMB_ADD_CRUMB_AND_SHRING: return addCrumAndShring(state, action);
        case BREADCRUMB_SHRINK_TO_CRUMB_FROM_START: return shrinkToCrumbFromStart(state, action);
        case BREADCRUMB_SET_SELECTED_CRUMB: return setSelectedCrumb(state, action);
        default:
            console.error('Unknown action type in Breadcrumb-Reducer', action.type);
    }
    return state;
}

// ------------------------------------------------------------------------------------------------
// -- 0. Reset State ------------------------------------------------------------------------------
// ------------------------------------------------------------------------------------------------
function resetState(state, { type: type, payload: { index: index } }) {
    const s: IBreadCrumbState = BREADCRUMB_INITIAL_STATE;
    return Object.assign({}, state, s);
}

function setInitialCrumb(state, { type: type, payload: { object: jsObj, index: index } }) {
    return tassign(state, {
        crumbs0: [jsObj]
    });
}

function addCrumb(state, { type: type, payload: { object: jsObj, index: index } }) {
    let _tmpArr: IBreadcrumbItem[] = null;
    if (!state.crumbs0) {
        _tmpArr = [jsObj];
    } else {
        _tmpArr = _.cloneDeep(state.crumbs0);

        if (!_.isEqual(_.last(_tmpArr), jsObj)) {
            _tmpArr.push(jsObj);
        }
    }
    _tmpArr = limitBreadCrumbs(_tmpArr);

    return tassign(state, {
        crumbs0: _tmpArr
    });
}

function limitBreadCrumbs(crumbs: IBreadcrumbItem[]) {
    if (crumbs.length > 5) {
        [, ...crumbs] = crumbs;
    }
    return crumbs;
}

function addCrumAndShring(state, { type: type, payload: { object: jsObj, index: index } }) {
    let _tmpArr: IBreadcrumbItem[] = null;

    if (!!state.crumbs0 && state.crumbs0.length > 0) {
        const i = _.findIndex(state.crumbs0, (obj: IBreadcrumbItem) => obj.value === jsObj.value);
        if (i === 0) {
            _tmpArr = [state.crumbs0[0]];
        } else if (i > 0 && i < state.crumbs0.length) {
            _tmpArr = _.slice(state.crumbs0, 0, i + 1);  // not including end
        }
    }

    if (!_tmpArr) {
        if (!state.crumbs0) {
            _tmpArr = [jsObj];
        } else {
            _tmpArr = _.cloneDeep(state.crumbs0);
            _tmpArr.push(jsObj);
        }
    }
    _tmpArr = limitBreadCrumbs(_tmpArr);

    return tassign(state, {
        crumbs0: _tmpArr
    });
}

function shrinkToCrumbFromStart(state, { type: type, payload: { object: value, index: index } }) {
    let _tmpArr: IBreadcrumbItem[] = state.crumbs0;

    if (!!state.crumbs0 && state.crumbs0.length > 0) {
        const i = _.findIndex(state.crumbs0, (obj: IBreadcrumbItem) => obj.value === value);
        if (i >= 0 && i < state.crumbs0.length) {
            _tmpArr = _.slice(state.crumbs0, 0, i + 1);  // not including end
        }
    }

    return tassign(state, {
        crumbs0: _tmpArr
    });
}

function setSelectedCrumb(state, { type: type, payload: { object: jsObj, index: index } }) {
    return tassign(state, {
        crumbSelected0: jsObj
    });
}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/core/components/breadcrumb/store/store.ts